export default __webpack_public_path__ + "static/media/format_study5.056bf92d.svg";